import { render, staticRenderFns } from "./SendInvitationModal.vue?vue&type=template&id=77ba93f2&scoped=true&"
import script from "./SendInvitationModal.vue?vue&type=script&lang=js&"
export * from "./SendInvitationModal.vue?vue&type=script&lang=js&"
import style0 from "./SendInvitationModal.vue?vue&type=style&index=0&id=77ba93f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba93f2",
  null
  
)

export default component.exports